import { gql, TypedDocumentNode } from "@apollo/client";

import {
  BlobStorageIntegration,
  Maybe,
  MutationBlobStorageIntegrationCreateArgs,
  MutationBlobStorageIntegrationDeleteArgs,
  MutationBlobStorageIntegrationUpdateArgs,
} from "types/generated";

type BlobStorageIntegrationMutationData = Pick<BlobStorageIntegration, "id" | "name">;

type CreateBlobStorageIntegrationMutation = {
  blobStorageIntegrationCreate: BlobStorageIntegrationMutationData;
};

type UpdateBlobStorageIntegrationMutation = {
  blobStorageIntegrationUpdate: BlobStorageIntegrationMutationData;
};

type DeleteBlobStorageIntegrationMutation = {
  blobStorageIntegrationDelete: Maybe<BlobStorageIntegrationMutationData>;
};

type CheckBlobStorageHasDefaultIntegrationQuery = {
  checkBlobStorageHasDefaultIntegration: Maybe<Pick<BlobStorageIntegration, "id">>;
};

export const CREATE_BLOB_STORAGE_INTEGRATION: TypedDocumentNode<
  CreateBlobStorageIntegrationMutation,
  MutationBlobStorageIntegrationCreateArgs
> = gql`
  mutation CreateBlobStorageIntegrationInVCS(
    $subtype: BlobStorageSubtype!
    $authMethod: BlobStorageAuthMethod!
    $baseURI: String!
    $region: String
    $endpoint: String
    $roleArn: String
    $accessKeyId: String
    $secretAccessKey: String
    $customInput: CustomVCSInput
  ) {
    blobStorageIntegrationCreate(
      subtype: $subtype
      authMethod: $authMethod
      baseURI: $baseURI
      region: $region
      endpoint: $endpoint
      roleArn: $roleArn
      accessKeyId: $accessKeyId
      secretAccessKey: $secretAccessKey
      customInput: $customInput
    ) {
      id
      name
    }
  }
`;

export const UPDATE_BLOB_STORAGE_INTEGRATION: TypedDocumentNode<
  UpdateBlobStorageIntegrationMutation,
  MutationBlobStorageIntegrationUpdateArgs
> = gql`
  mutation UpdateBlobStorageIntegration(
    $subtype: BlobStorageSubtype!
    $authMethod: BlobStorageAuthMethod!
    $baseURI: String!
    $region: String
    $endpoint: String
    $roleArn: String
    $accessKeyId: String
    $secretAccessKey: String
    $customInput: CustomVCSUpdateInput
  ) {
    blobStorageIntegrationUpdate(
      subtype: $subtype
      authMethod: $authMethod
      baseURI: $baseURI
      region: $region
      endpoint: $endpoint
      roleArn: $roleArn
      accessKeyId: $accessKeyId
      secretAccessKey: $secretAccessKey
      customInput: $customInput
    ) {
      id
      name
    }
  }
`;

export const DELETE_BLOB_STORAGE_INTEGRATION: TypedDocumentNode<
  DeleteBlobStorageIntegrationMutation,
  MutationBlobStorageIntegrationDeleteArgs
> = gql`
  mutation DeleteBlobStorageIntegration($id: ID!) {
    blobStorageIntegrationDelete(id: $id) {
      id
      name
    }
  }
`;

export const CHECK_BLOB_STORAGE_HAS_DEFAULT_INTEGRATION: TypedDocumentNode<CheckBlobStorageHasDefaultIntegrationQuery> = gql`
  query CheckBlobStorageHasDefaultIntegration {
    checkBlobStorageHasDefaultIntegration: blobStorageIntegration {
      id
    }
  }
`;
